import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import {
    Grid,
    Button,
    Box,
    Typography,
} from '@mui/material';
import { Input, CommonModal, Select } from '../../Common';
import Routes from '../../../routes';
import { trakrefBlue } from '../../../color_utils';

const RegistrationTypeModal = ({
    payload,
    modalOpen,
    onClose,
    refreshRequired
}) => {
    const [instanceId, setInstanceId] = useState(null);
    const [renewalPeriod, setRenewalPeriod] = useState(null);
    const [registrationName, setRegistrationName] = useState(null);
    const [instanceOption, setInstanceOption] = useState([]);
    const [ErrorObject, setErrorObject] = useState({});

    var isUpdate = payload !== null && payload !== undefined && payload.id;
    const fetchData = async () => {
        const response = await fetch(Routes.Instance.GetActiveInstance());

        if (response.status === 200) {
            const data = await response.json();
            // Add a default item representing "All Active Accounts" with id 0
            const defaultItem = { id: 0, name: "[All Active Accounts]" };
            setInstanceOption([defaultItem, ...data]);
        }
    };

    const addRegistrationType = async () => {
        var isValid = validateFields();
        if (!isValid) {
            return;
        }

        var body = {
            Name: registrationName,
            RenewalPeriodDays: renewalPeriod,
            InstanceID: instanceId
        };
        if (isUpdate) {
            body = {
                Id: payload.id,
                ...body
            };
        }
        const postConfig = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        };
        const UpdateResponse = await fetch(Routes.Location.AddLocationRegistrationType(), postConfig);

        if (UpdateResponse.status === 200) {
            onClose();
            refreshRequired();
            return toast.success(`The Registration Type has been successfully ${isUpdate ? 'updated' : 'created' }.`, { duration: 6000 });
        }
        return toast.error(`There was an error ${isUpdate ? 'updating' : 'creating' } the Registration Type. Please try again.`, { duration: 6000 });
    };

    const validateFields = () => {
        const errorObject = {};
        let isValid = true;

        if (!registrationName) {
            errorObject.registrationName = true;
        }

        if (!renewalPeriod) {
            errorObject.renewalPeriod = true;
        }
        if (parseInt(renewalPeriod) === 0) {
            errorObject.renewalPeriod = "Please enter a valid value";
        }
        if (!instanceId && instanceId !== 0) {
            errorObject.instanceId = true;
        }

        setErrorObject(errorObject);
        if (Object.values(errorObject).some(state => state == true || typeof state == 'string')) {
            isValid = false;
        }
        return isValid;
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (payload) {
            setRegistrationName(payload.name);
            setRenewalPeriod(payload.renewalPeriodDays);
            setInstanceId(payload.instanceID);
        } else {
            setRegistrationName(null);
            setRenewalPeriod(null);
            setInstanceId(null);
        }
    }, [payload]);

    const header = payload === null ? "Create Registration Type" : "Edit Registration Type";

    return (
        <CommonModal
            open={modalOpen}
            close={onClose}
            header={header}
        >
            <Grid container pl={10} pr={10}>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        required
                        variant="outlined"
                        label="Registration Type"
                        value={registrationName}
                        error={ErrorObject.registrationName}
                        onChange={e => setRegistrationName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        required
                        variant="outlined"
                        type={'number'}
                        disableDecimal={true}
                        label="Renewal Period (Days)"
                        value={renewalPeriod}
                        error={ErrorObject.renewalPeriod}
                        helperText={typeof ErrorObject.renewalPeriod === "string" ? ErrorObject.renewalPeriod : "This field is required"}
                        onChange={e => setRenewalPeriod(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Select
                        label="Account"
                        options={instanceOption}
                        onChange={e => {
                            setInstanceId(e.target.value);
                        }}
                        variant="outlined"
                        value={instanceId}
                        error={ErrorObject.instanceId}
                        required
                        sx={{ width: '100%' }}
                    />
                </Grid>
                <Grid item xs={12} lg={12} align='center'>
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <Button
                            fullWidth
                            size='large'
                            variant='contained'
                            onClick={addRegistrationType}
                            style={{
                                backgroundColor: trakrefBlue
                            }}
                        >
                            <Typography sx={{ padding: '1% 0%', color: '#fff', fontSize: 17, fontWeight: 400 }}>
                                {isUpdate ? "EDIT" : "CREATE"} REGISTRATION TYPE
                            </Typography>
                        </Button>
                    </Box>
                </Grid>

            </Grid>
        </CommonModal>
    );
};

export default RegistrationTypeModal;
